import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class UserLoginService {

constructor( private authService: MsalService,) { }

 isLoggedIn() {
    return this.authService.instance.getAllAccounts().length > 0 ? true : false
  }


}
